<template>
  <div>
    <div v-if="showTitle" class="d-flex justify-space-between">
      <p class="font-weight-black"><span v-if="allowEdit">EDITAR</span> ESTADO</p>
    </div>
    <v-form ref="formState" lazy-validation>
      <v-row class="fill-height px-3 pt-2">
        <v-col cols="12">
          <v-autocomplete
            v-model="state"
            :value="getTicket.state"
            :items="getActiveTicketStates"
            :readonly="getTicketStatesMap[getTicket.state].final"
            :rules="stateCustomRules"
            style="font-size: 15px"
            item-text="name"
            item-value="id"
            label="Estado"
            class="pt-2"
          />
        </v-col>
        <v-col
          v-if="
            getTicket.state === $ticketStates.ORDEN_CREADA &&
            getTicket.order_id &&
            [$roles.SUPER_ADMIN, $roles.ADMIN, $roles.ENTREPRENEUR].includes(getAgent.role)
          "
          cols="12"
          class="pt-0 text-right"
        >
          <v-btn
            text
            small
            :to="{ name: 'order_detail', params: { id: getTicket.order_id } }"
            target="_blank"
            color="primary"
          >
            <v-icon x-small class="pr-2"> fas fa-external-link-alt </v-icon> Ver detalle de la orden
          </v-btn>
        </v-col>
        <v-col v-if="responseMessage" cols="12">
          <v-alert text type="error">
            {{ responseMessage }}
          </v-alert>
        </v-col>
        <v-col v-if="allowEdit" cols="12" class="text-center">
          <v-btn :loading="loading" small rounded color="primary" @click="onSave"> Guardar </v-btn>
          <v-btn small rounded @click="onCancel"> Cancelar </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "TicketCardState",
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
    editState: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      state: null,
      loading: false,
      responseMessage: null,
    };
  },
  computed: {
    ...mapGetters([
      "getBusiness",
      "getAgent",
      "getTicket",
      "getActiveTicketStates",
      "getTicketStatesMap",
      "getTicketDefaultObjections",
    ]),
    allowEdit() {
      return this.getTicket && this.getTicket.state !== this.state;
    },
    stateCustomRules() {
      return [
        (v) =>
          v !== this.$ticketStates.ORDEN_CREADA ||
          (v === this.$ticketStates.ORDEN_CREADA && this.getTicket.products && this.getTicket.products.length > 0) ||
          "Es necesario tener productos relacionados para crear una orden",
        (v) =>
          v !== this.$ticketStates.ORDEN_CREADA ||
          (v === this.$ticketStates.ORDEN_CREADA && !!this.getTicket.contact_id) ||
          "Es necesario que la oportunidad tenga un contacto vinculado",
        (v) =>
          v !== this.$ticketStates.DESESTIMADO ||
          this.getBusiness.id === "intermotorsdealers" ||
          (v === this.$ticketStates.DESESTIMADO && !!this.getTicket.objection) ||
          "Es necesario que seleccione una objeción en la oportunidad",
      ];
    },
  },
  watch: {
    "getTicket.state"(value) {
      if (!this.state) this.state = value;
    },
    allowEdit(value) {
      this.$emit("update:editState", value);
    },
  },
  created() {
    this.state = this.getTicket.state;
  },
  methods: {
    ...mapActions(["setTicketState"]),
    async onSave() {
      try {
        this.loading = true;
        this.responseMessage = null;

        if (!this.$refs.formState.validate())
          throw new Error("El formulario contiene datos inválidos, por favor verifique y vuelva a intentar");

        await this.setTicketState({
          ticket_id: this.getTicket.id,
          state: this.state,
        });
      } catch (error) {
        this.responseMessage = error.message || "Ocurrió un problema al cambiar de estado";
      } finally {
        this.loading = false;
      }
    },
    async onCancel() {
      this.state = this.getTicket.state;
      this.responseMessage = null;
    },
  },
};
</script>
